import React from "react";
import styles from "./header.module.css";

export const Header = (props) => {
  return (
    <header id="header" className={styles.header}>
      <div className={styles.inner}>
        {/* Decorative Background Image */}
        <div className={styles.decorativeWrap}>
          <img
            src="/img/intro-bg.jpg"
            alt="Background"
            className={styles.decorative}
          />
        </div>

        {/* Paragraph Text */}
        <p className={styles.text}>
          {props.data ? props.data.paragraph : "Loading..."}
        </p>

        {/* Call to Action */}
        <a href="#solutions" className="btn btn-custom btn-lg page-scroll">
          Learn More
        </a>
      </div>
    </header>
  );
};
